<template>
  <button
    :disabled="disabled"
    :style="btnColor"
    @click="$emit('click', $event)"
    class=" rounded focus:outline-none"
    :class="buttonSize"
  >
    <slot></slot>
  </button>
</template>
<script>
import colors from "@/utils/colors";
export default {
  // If you want the theme color to be used for the button
  // dont pass any color prop, if you want a specific color, pass it
  props: {
    size: {
      type: String,
      default: "md",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "white",
    },
    textColor: {
      type: String,
      default: "#ffffff",
    },
  },
  data() {
    return {
      sizes: {
        sm: ["py-2", "px-2", "text-xs"],
        md: ["py-2", "px-8"],
      },
      colors: Object.values(colors),
    };
  },
  computed: {
    buttonSize() {
      return this.sizes[this.size].join(" "); //mad ooo!
    },
    btnColor() {
      if (this.color != "white") {
        return `border-color: ${this.color}; color: ${this.color}; font-weight: 600`;
      } else if (!this.colors.includes(this.color) && this.color != "white") {
        return `border-color: ${this.color}; font-weight: 600`;
      } else {
        return `color: ${this.color}; font-weight: 600`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
button {
  color: black;
  border: 2px solid color(lms-tenant);
  // border-color: #4caf50;
}
</style>
